export default function EFQuestionnaire(props) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M26.5 32.5H42.75" stroke="url(#paint0_linear_2302_14541)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M42.75 40H26.5" stroke="url(#paint1_linear_2302_14541)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.5 25H42.75V17.5H26.5V25Z"
                stroke="url(#paint2_linear_2302_14541)"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.75 32.8613H10.25V45.7201C10.2573 48.0847 12.1716 49.999 14.5363 50.0064"
                stroke="url(#paint3_linear_2302_14541)"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.3234 10C19.9427 10 18.8234 11.1193 18.8234 12.5V45.7191C18.8161 48.0829 16.9017 49.998 14.5371 50.0053H45.9699C48.3338 49.998 50.2489 48.0829 50.2554 45.7191V12.5C50.2554 11.1193 49.1361 10 47.7554 10H21.3234Z"
                stroke="url(#paint4_linear_2302_14541)"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_2302_14541" x1="26.4853" y1="32.5" x2="33.4489" y2="24.9306" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint1_linear_2302_14541" x1="26.4853" y1="40" x2="33.4489" y2="32.4306" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint2_linear_2302_14541" x1="26.4853" y1="17.5" x2="41.3642" y2="15.3436" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint3_linear_2302_14541" x1="10.2432" y1="32.8613" x2="17.2486" y2="32.6563" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
                <linearGradient id="paint4_linear_2302_14541" x1="14.5048" y1="9.99996" x2="47.7776" y2="8.0128" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
            </defs>
        </svg>
    );
}
